import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Image, ImagePreview, Input, Picker, Popup, Toast } from 'react-vant';
import { apiGetH5Refund, apiGetH5RefundDetail, apiOssUpload } from '../api';
import AppBar from '../components/appBar';
import Loading from '../components/loading';
import Page from '../components/page';
import { cancelReasonData } from '../utils/source';
import { cloneDeep, dictLabel, parseLocationParams } from '../utils/utils';

export default function ApplyRefundPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [id, setid] = useState<string>();
  const [resonVisible, setResonVisible] = useState(false);
  const [payAmount, setpayAmount] = useState<number>();
  const [refundReason, setrefundReason] = useState<string>();
  const [refundDesc, setrefundDesc] = useState<string>();
  const [practicalAmount, setpracticalAmount] = useState<number>();
  const [refundImgPath, setrefundImgPath] = useState<string[]>([]);
  // 上传照片显示loading
  const [uploadLoading, setuploadLoading] = useState<boolean>(false);

  useEffect(() => {
    let _p = parseLocationParams(location.search) ?? {};
    if (_p.id) {
      setid(_p.id);
      getH5RefundDetail(_p.id);
    }
  }, []); // eslint-disable-line

  async function getH5RefundDetail(id: string) {
    try {
      let res = await apiGetH5RefundDetail({ id });
      let data = res.data;
      if (data.code === 200) {
        setpayAmount(Number(data?.data?.order?.payAmount ?? 0));
      }
    } catch (error) {}
  }

  const handleDecimalInput = (e: any) => {
    let val = e.target.value
      .replace(/[^0-9.]/g, '')
      .replace(/\.{2,}/g, '.')
      .replace(/^(\d+)\.(\d{0,2}).*$/, '$1.$2');
    if (val === '.' || !val) {
      setpracticalAmount(val);
      return;
    }
    const num = Number(val);
    if (num < 0.01) {
      val = '0.01';
      Toast('申退金额不能小于0.01');
    }
    if (num > Number(payAmount ?? 0)) {
      val = payAmount;
      Toast(`申退金额不能大于${payAmount?.toFixed(2)}`);
    }
    setpracticalAmount(val);
  };

  function verifyRefund() {
    let msg = '';
    if (!refundReason) {
      msg = '请选择退款原因';
    } else if (!practicalAmount) {
      msg = '请输入退款金额';
    }
    return msg;
  }

  async function handleRefund() {
    if (!!verifyRefund()) return Toast(verifyRefund());
    setuploadLoading(true);
    try {
      let res = await apiGetH5Refund({
        id,
        refundReason,
        practicalAmount,
        refundDesc,
        refundImgPath: (refundImgPath ?? []).join(','),
      });
      let data = res.data;
      if (data.code === 200) {
        navigate(-1);
      } else {
        Toast(data?.msg ?? '网络繁忙，操作失败');
      }
    } catch (error) {
    } finally {
      setuploadLoading(false);
    }
  }

  // 上传照片
  const chooseImg = async (t: FileList | null) => {
    if (t && t[0]) {
      if (t[0].size / 1024 / 1024 > 10) return Toast('照片不可以上传超过10MB');
      setuploadLoading(true);
      try {
        const res = await apiOssUpload(t[0]);
        if (res) {
          setrefundImgPath([...refundImgPath, res]);
        }
      } catch (error) {
      } finally {
        setuploadLoading(false);
      }
    }
  };
  function handleRemoveImg(idx: number) {
    let arr = cloneDeep(refundImgPath);
    arr.splice(idx, 1);
    setrefundImgPath(arr);
  }

  let cancelReasonOptions = cancelReasonData.map((item) => ({ value: Number(item.value!), text: item.label }));
  return (
    <Page
      className="applyrefund-page d-flex-c"
      contentClassName="flex-1 h-1 mb-10 overflow-y"
      appBar={<AppBar className="bg-transparent" title="申请退款" />}
    >
      <div className="m-10 p-15 bg-white border-radius-8">
        <div className="mb-20 d-flex-r ai-center jc-between">
          <span>退款原因</span>
          <div className="d-flex-r ai-center" onClick={() => setResonVisible(true)}>
            {refundReason ? dictLabel(refundReason, cancelReasonData) : <span className="text-color-9">请选择</span>}
            <img
              className="w-15 ml-2"
              src={`/pic/${refundReason ? 'icon_refund_right' : 'icon_refund_right_9'}.png`}
              alt=""
            />
          </div>
        </div>
        <div className="d-flex-r ai-start">
          <span>申请退款金额</span>
          <div className="flex-1 d-flex-c ai-end">
            <input
              className="input text-right font-size-20"
              type="number"
              placeholder="请输入金额"
              value={practicalAmount}
              onInput={(v) => handleDecimalInput(v)}
            />
            <span className="font-size-12 text-color-6 mt-10">最多可输入商品金额¥{payAmount?.toFixed(2)}</span>
          </div>
        </div>
      </div>
      <div className="ml-10 mb-10 p-15 bg-white border-radius-8">
        <div className="text-color-3">
          补充描述<span className="text-color-9 font-size-12 ml-5">选填</span>
        </div>
        <Input.TextArea
          className="input-textarea p-10 bg-555 border-radius-8 mt-10"
          placeholder="请填写补充描述，有助于您更快处理问题"
          autoSize={{ minHeight: 80, maxHeight: 120 }}
          value={refundDesc}
          onChange={(v) => setrefundDesc(v)}
        />
        <div className="d-flex-r flex-wrap mt-10">
          {refundImgPath.map((i, idx) => (
            <div className="pos-r mr-10">
              <Image
                key={idx}
                width="80"
                height="80"
                fit="cover"
                src={i}
                onClick={() => ImagePreview.open({ images: [i] })}
              />
              <img
                className="pos-a t-0 close-img"
                src="/pic/icon_close.png"
                alt=""
                onClick={() => handleRemoveImg(idx)}
              />
            </div>
          ))}
          {refundImgPath.length < 3 && (
            <div className="border border-radius-8 p-10 pl-15 pr-15 pos-r">
              <div className="d-flex-c ai-center font-size-12 text-color-9">
                <img className="w-20 mb-5" src="/pic/icon_upload.png" alt="" />
                <span>上传凭证</span>
                <span>(选填)</span>
              </div>
              <input
                className="upload-input bw-100 bh-100"
                type="file"
                accept=".jpg,.png,.jpeg"
                onChange={(e) => {
                  chooseImg(e.target.files);
                }}
              />
            </div>
          )}
        </div>
        <div className="mt-10 text-color-9">* 支持上传最多三张凭证</div>
      </div>
      <div
        className="submit-btn m-10 mt-20 pt-10 pb-10 text-center bg-p border-radius-20 text-color-white"
        onClick={handleRefund}
      >
        发起退款申请
      </div>

      {uploadLoading && (
        <Loading
          tips={'正在加载中...'}
          loadingClass="bh-100 overflow-hidden text-color-white d-flex-r ai-center jc-center mt-0 bg-shallow"
        />
      )}
      <Popup position="bottom" visible={resonVisible}>
        <Picker
          title="退款原因"
          defaultValue={refundReason}
          columns={cancelReasonOptions}
          onCancel={() => setResonVisible(false)}
          onConfirm={(v: string) => {
            setrefundReason(v !== undefined ? v : '');
            setResonVisible(false);
          }}
        />
      </Popup>
    </Page>
  );
}
